/**
 * O painel da Weloze (PLAN §9, fatia j).
 *
 * A ordem dos campos aqui é a ordem da tela, e ela responde a uma decisão: o
 * painel diz **"o que preciso fazer hoje"** primeiro, e **"como está a
 * carteira"** depois. Painel que abre com gráfico responde a uma pergunta que
 * ninguém fez ao abrir o sistema de manhã.
 *
 * **O que deliberadamente não existe aqui:** o IQW médio da carteira como
 * número de destaque. Com 17 avaliadas de 47 ele parece a nota da base de
 * fornecedores, mas é a nota de quem entregou naquele mês — e a média esconde
 * justamente o caso que interessa. A distribuição conta a mesma coisa sem a
 * armadilha, e o termômetro conta o resto.
 */
// ---------------------------------------------------------------------------
// Termômetro
// ---------------------------------------------------------------------------
export const ThermometerLevel = {
    GREEN: 'GREEN',
    YELLOW: 'YELLOW',
    RED: 'RED',
};
export const THERMOMETER_LABEL = {
    GREEN: 'Sob controle',
    YELLOW: 'Atenção',
    RED: 'Ação necessária',
};
// ---------------------------------------------------------------------------
// Ação — o que precisa de mim hoje
// ---------------------------------------------------------------------------
export const ActionKey = {
    PERIOD_TO_CLOSE: 'PERIOD_TO_CLOSE',
    CERTIFICATIONS_PENDING: 'CERTIFICATIONS_PENDING',
    RNC_OVERDUE: 'RNC_OVERDUE',
    STORES_WITH_PENDENCIES: 'STORES_WITH_PENDENCIES',
    ACTION_PLANS_OVERDUE: 'ACTION_PLANS_OVERDUE',
};
//# sourceMappingURL=dashboard.js.map